import { SparklesIcon, UserIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";
import { Button } from "@/components/ui/button";

export const StafferAgentMessagingBanner = ({
  active,
  onTakeOver,
}: {
  active: boolean;
  onTakeOver: () => void;
}) => {
  if (active) {
    return (
      <Column className="gap-1.5 pb-3">
        <Row className="items-center gap-2 rounded-md border border-blue-100 bg-blue-50/60 px-3 py-2">
          <SparklesIcon className="h-3.5 w-3.5 shrink-0 text-blue-500" />
          <Text truncate className="text-xs font-medium text-blue-900">
            AI handling this conversation
          </Text>
        </Row>
        <Row className="justify-end">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onTakeOver}
            className="h-7 px-2 text-xs font-medium text-blue-700 hover:bg-blue-50 hover:text-blue-900"
          >
            Take over
          </Button>
        </Row>
      </Column>
    );
  }

  return (
    <Row className="mb-3 items-center gap-2">
      <UserIcon className="h-3.5 w-3.5 shrink-0 text-blue-600" />
      <Text truncate className="text-xs font-medium text-blue-700">
        Manual messaging mode
      </Text>
    </Row>
  );
};
